// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const localConfig = {
  serverLink: 'http://localhost:3000'
};

const stageConfig = {
  serverLink: 'https://stnode.permitconnect.us:3000'
};

const productionConfig = {
  serverLink: 'https://node.permitconnect.us:3000'
};

export const environment = {
  production: false,
  googleMapAPIKey: 'AIzaSyAf2IZLhSyMcpxc6ryUlzACo5JwF9j5G34',
  // ...localConfig
  // ...stageConfig
  ...productionConfig
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
